export function initFigureLightbox(): void {
  const links = [...document.querySelectorAll<HTMLAnchorElement>('a.fig-zoom')];
  if (!links.length) return;

  let overlay: HTMLElement | null = null;

  const close = (): void => {
    if (!overlay) return;
    overlay.remove();
    overlay = null;
    document.body.style.overflow = '';
  };

  const open = (href: string, alt: string): void => {
    close();
    overlay = document.createElement('div');
    overlay.className = 'fig-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', alt || 'Figure at full resolution');

    const img = document.createElement('img');
    img.src = href;
    img.alt = alt;
    overlay.appendChild(img);
    overlay.addEventListener('click', close);

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
  };

  for (const link of links) {
    link.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey) return; // allow open-in-new-tab
      event.preventDefault();
      open(link.href, link.querySelector('img')?.alt ?? '');
    });
  }

  addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
}
